import flower from '../../images/quote/flower.svg'
import quote1 from '../../images/quote/image-1.jpg'
import quote2 from '../../images/quote/image-2.jpg'
import quote3 from '../../images/quote/image-3.jpg'
import quote4 from '../../images/quote/image-4.jpg'


const Quote: React.FC = () => {
    
    return (
        <section className="wpo-quote-section">
            <div className="container">
                <div className="quote-wrap">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="quote-title">
                                <h2 className="poort-text poort-in-right">“You are my today and all of my tomorrows.”</h2>
                                <p>Your smile is so gentle, yet powerful enough to light up the darkest corners of my
                                    soul. It carries warmth, hope, and a
                                    kind of magic the night sky could only dream of. While stars twinkle far away in the
                                    heavens, your smile glows right
                                    here beside me— real, radiant, and made just for my heart to find peace. It’s not
                                    just beauty I see; it’s love, comfort,
                                    and home all at once.</p>
                                <div className="flower">
                                    <img src={flower} alt="flower"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="left-images">
                <div className="image-1 wow fadeInDown" data-wow-duration="1200ms">
                    <div className="image-move">
                        <img src={quote1} alt=""/>
                    </div>
                </div>
                <div className="image-2 wow fadeInUp" data-wow-duration="1200ms">
                    <div className="image-move">
                        <img src={quote2} alt=""/>
                    </div>
                </div>

            </div>
            <div className="right-images">
                <div className="image-1 wow fadeInDown" data-wow-duration="1200ms">
                    <div className="image-move2">
                        <img src={quote4} alt=""/>
                    </div>
                </div>
                <div className="image-2 wow fadeInRight" data-wow-duration="1200ms">
                    <div className="image-move2">
                        <img src={quote3} alt=""/>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Quote;